import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";
import metadataQueryKeys from "shared/services/metadataQueryKeys";

export const REFERENCE_DOT_WALK_MAX_DEPTH_PROPERTY = "record.filter.reference_dot_walk.max_depth";
export const DEFAULT_REFERENCE_DOT_WALK_MAX_DEPTH = 5;
const MIN_REFERENCE_DOT_WALK_MAX_DEPTH = 1;
const MAX_REFERENCE_DOT_WALK_MAX_DEPTH = 10;

const clampDepth = (value: number) =>
    Math.min(MAX_REFERENCE_DOT_WALK_MAX_DEPTH, Math.max(MIN_REFERENCE_DOT_WALK_MAX_DEPTH, value));

export const useReferenceDotWalkMaxDepth = () => {
    const query = useQuery({
        queryKey: metadataQueryKeys.property(REFERENCE_DOT_WALK_MAX_DEPTH_PROPERTY),
        queryFn: () => new RecordManagement("sys_properties")
            .where("name", REFERENCE_DOT_WALK_MAX_DEPTH_PROPERTY)
            .first(),
        staleTime: 1000 * 60 * 5,
        retry: false,
    });

    const configuredValue = Number((query.data as any)?.value);
    const maxDepth = Number.isFinite(configuredValue) && configuredValue > 0
        ? clampDepth(Math.floor(configuredValue))
        : DEFAULT_REFERENCE_DOT_WALK_MAX_DEPTH;

    return {
        ...query,
        maxDepth,
    };
};
